import { colors } from "@/styles/colors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	"@keyframes shadowPulse": {
		"0%": { boxShadow: `0 0 0 0 ${colors.purple[200]}` },
		"70%": { boxShadow: "0 0 0 8px transparent" },
		"100%": { boxShadow: "0 0 0 0 transparent" }
	},
	card: {
		padding: 24,
		cursor: "pointer",
		display: "flex",
		flexDirection: "column",
		gap: 12,
		borderColor: colors.gray[200],
		transition: "transform 0.2s ease, border-color 0.2s ease",
		"&:hover": {
			transform: "scale(1.02)",
			borderColor: colors.purple[500]
		},
		"&:hover $iconWrapper": {
			backgroundColor: colors.purple[100],
			color: colors.purple[500]
		}
	},
	pulsing: {
		animation: "$shadowPulse 2s ease-out infinite"
	},
	iconWrapper: {
		display: "inline-flex",
		padding: 8,
		borderRadius: 8,
		backgroundColor: colors.gray[100],
		color: colors.gray[500],
		transition: "background-color 0.2s ease, color 0.2s ease",
		width: "fit-content",
		"& svg": {
			display: "block"
		}
	}
})

export default useStyles
